module.exports = __webpack_public_path__ + "img/theroom_amp0_thumb.825187e9.jpg";